/** @format */

// 外部链接跳转进来
import React from 'react'
import { useParams, useHistory } from 'react-router-dom'
import useGlobalData from 'src/hooks/useGlobalData'

interface ParamsObj {
  instanceName: string
  instanceId: string
  page: string
  regionName?: string
  productType?: string
}
const MonitorClouOuterView: React.FC<any> = () => {
  const { instanceName, instanceId, page, regionName, productType } = useParams<ParamsObj>()
  const productMenu = useGlobalData('productMenu')
  const history = useHistory()

  React.useEffect(() => {
    if (instanceName && instanceId && regionName) {
      localStorage.setItem('systemId', regionName)
      const prtType = productType || '0'
      const viewName = productMenu.find(menu => {
        return menu.productType === parseInt(prtType)
      })?.screenName
      history.push(
        viewName
          ? // eslint-disable-next-line max-len
            `/monitor/list/overview/${instanceName}/${instanceId}/${prtType}/${page}/${viewName}/${regionName}`
          : '/monitor/generalview/home'
      )
    } else {
      history.push('/monitor/generalview/home')
    }
  }, [instanceName, instanceId, regionName, productType])

  return <div></div>
}

export default MonitorClouOuterView
